import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { UsuarioPapel } from '../types';

interface UserInfo {
  encrypted_yw_id?: string;
  photo_url?: string;
  display_name?: string;
  // Campos para unidade
  unidade_id?: number;
  username?: string;
  nome?: string;
  codigo?: string;
  cpf?: string;
  email?: string;
  telefone?: string;
  cargo?: string;
  logo_url?: string;
}

type UserType = 'admin' | 'unidade' | 'approver' | 'operator';

interface AuthState {
  user: UserInfo | null;
  userType: UserType | null;
  userRole: UsuarioPapel | null;
  selectedUnidadeId: number | null;
  isImpersonating: boolean;
  isLoading: boolean;
  setUser: (user: UserInfo | null, userType: UserType, userRole: UsuarioPapel) => void;
  setSelectedUnidade: (unidadeId: number | null) => void;
  setImpersonating: (impersonating: boolean) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
  isAdmin: () => boolean;
  isCliente: () => boolean;
  isApprover: () => boolean;
  isOperator: () => boolean;
  isAdminRole: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      userType: null,
      userRole: null,
      selectedUnidadeId: null,
      isImpersonating: false,
      isLoading: true,
      setUser: (user, userType, userRole) => set({ user, userType, userRole, isLoading: false }),
      setSelectedUnidade: (unidadeId) => set({ selectedUnidadeId: unidadeId }),
      setImpersonating: (impersonating) => set({ isImpersonating: impersonating }),
      setLoading: (loading) => set({ isLoading: loading }),
      logout: () => set({ user: null, userType: null, userRole: null, selectedUnidadeId: null, isImpersonating: false }),
      isAdmin: () => get().userType === 'admin',
      isCliente: () => get().userType === 'unidade',
      isApprover: () => get().userRole === 'aprovador',
      isOperator: () => get().userRole === 'operador',
      isAdminRole: () => get().userRole === 'admin' || get().userRole === 'superadmin',
    }),
    {
      name: 'axis-auth-storage',
      partialize: (state) => ({ 
        user: state.user,
        userType: state.userType,
        userRole: state.userRole,
        selectedUnidadeId: state.selectedUnidadeId,
        isImpersonating: state.isImpersonating
      }),
    }
  )
);
